import React from 'react';
import FormField from '@cloudscape-design/components/form-field';
import Input from '@cloudscape-design/components/input';
import Select from '@cloudscape-design/components/select';
import SpaceBetween from '@cloudscape-design/components/space-between';

const USER_TYPES = ['PERSON', 'TEAM', 'SYSTEM', 'EXTERNAL'];

interface UserFieldsProps {
  userType: string;
  user: string;
  onUserTypeChange: (v: string) => void;
  onUserChange: (v: string) => void;
}

/**
 * User Type dropdown and User text field, as used in the policy create modals.
 * Wrapped in its own SpaceBetween: the modal's SpaceBetween would treat a fragment as one item and put no gap between the two fields.
 */
export const UserFields: React.FC<UserFieldsProps> = ({ userType, user, onUserTypeChange, onUserChange }) => (
  <SpaceBetween size="m">
    <FormField label="User Type">
      <Select
        selectedOption={{ value: userType, label: userType }}
        options={USER_TYPES.map(t => ({ value: t, label: t }))}
        onChange={({ detail }) => onUserTypeChange(detail.selectedOption.value!)}
      />
    </FormField>
    <FormField label="User">
      <Input value={user} onChange={({ detail }) => onUserChange(detail.value)} placeholder="alias or team" />
    </FormField>
  </SpaceBetween>
);
